import React, { useEffect, useRef, useState } from "react";
import MieszkaniecWydrukNaglowek from "./MieszkaniecWydrukNaglowek.js";
import MieszkaniecWydrukKonto from "./MieszkaniecWydrukKonto.js";
import MieszkaniecWydrukStawki from "./MieszkaniecWydrukStawki.js";
import MieszkaniecWydrukTHead from "./MieszkaniecWydrukTHead.js";
import MieszkaniecWydrukTFooter from './MieszkaniecWydrukTFooter.js';
import MieszkaniecWydrukStawkiJednorazowe from "./MieszkaniecWydrukStawkiJednorazowe.js";
import MieszkaniecWydrukStawkiJednorazoweInd from './MieszkaniecWydrukStawkiJednorazoweInd.js';
import MieszkaniecWydrukStawkiWoda from "./MieszkaniecWydrukStawkiWoda.js";
import MieszkaniecWydrukDokument from "./MieszkaniecWydrukDokument.js";

const MieszkaniecWydrukA4 = props => {

    const { componentRef, udzialyKonta_a, mieszkaniec, tablicaCzynszeAkt, stawkiOst, stawkiJednorazowe, stawkiJednorazoweInd, lokale, ulice, grupy_a, miesiac, grupa_numer, wodaMsc, procent } = props;

    // const componentRef = useRef(null);

    const [licznik, setLicznik] = useState(0)
    const [licznikJednorazowe, setLicznikJednorazowe] = useState(licznik);

    useEffect( () => setLicznikJednorazowe(licznik), [licznik])
    useEffect( () => setLicznik( Object.keys(stawkiOst).filter(key => key.includes("czy_") && stawkiOst[key] == 1)?.length ), [stawkiOst]);
    useEffect( () => setLicznikJednorazowe( Object?.keys(stawkiJednorazowe).filter(key => key.includes("czy") && stawkiJednorazowe[key] == 1).length ) , [stawkiJednorazowe])

    const puste = Array(6).fill(null).map((_, index) => (
        <td
            key={index}
            style={{
                borderLeft: '1px solid black',
                borderRight: '1px solid black',
                padding: '3cm 0 0 0'
            }}
        />
    ));

    return (
        <div 
            style={{
                // position: 'absolute',
                // top: 0,
                // left: '-9999px',
                width: '21cm',
                height: '29.7cm',
                backgroundColor: 'white',
                boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                padding: '15mm 15mm',
                boxSizing: 'border-box',
                maxWidth: '100%',
                maxHeight: '100%',
                position: 'relative'
            }} 
            ref={componentRef ? componentRef : null}
        >
            <MieszkaniecWydrukNaglowek
                udzialyKonta_a = {udzialyKonta_a}
                mieszkaniec = {mieszkaniec}
                lokale = {lokale}
                ulice = {ulice}
                grupy_a = {grupy_a}
                miesiac = {miesiac}
            />
            <section
                style={{
                    margin: '10mm 0 0 0'
                }}
            >
                <table
                    style={{
                        fontSize: '13px',
                        borderCollapse: 'collapse',
                        width: '100%'
                    }}
                >
                    <MieszkaniecWydrukTHead />
                    <tbody>
                        <MieszkaniecWydrukStawki
                            tablicaCzynszeAkt={tablicaCzynszeAkt}
                            stawkiOst={stawkiOst}
                        />
                        <MieszkaniecWydrukStawkiJednorazowe
                            stawkiJednorazowe={stawkiJednorazowe}
                            miesiac={miesiac}
                            licznik={licznik}
                            setLicznikJednorazowe={setLicznikJednorazowe}
                        />
                        <MieszkaniecWydrukStawkiJednorazoweInd
                            stawkiJednorazoweInd={stawkiJednorazoweInd}
                            licznikJednorazowe={licznikJednorazowe}
                        />
                        <MieszkaniecWydrukStawkiWoda
                            wodaMsc={wodaMsc}
                            procent={procent}
                            licznik={licznik + (stawkiJednorazoweInd?.length || 0)}
                        />
                        <tr>
                            {puste}
                        </tr>
                        <MieszkaniecWydrukTFooter
                            tablicaCzynszeAkt={tablicaCzynszeAkt}
                            procent={procent}
                        />
                    </tbody>
                </table>
            </section>
            <MieszkaniecWydrukKonto
                udzialyKonta_a={udzialyKonta_a}
            />
            <MieszkaniecWydrukDokument />
        </div>
    )
}

export default MieszkaniecWydrukA4;